import React from 'react'
import { utility } from '../../../utility/utility';
import { OTT_POSTER_TYPE, OTTROUTETYPE } from '../../../constant';

const EpisodeCard = (props) => {

    const { ref, AssetWrapper, ottSetting = {}, style = {}, onClick, onMouseEnter, focused, asset = {}, isFree = false, isLoggedIn = false, isWeb = false, crown } = props;

    return (
        <div ref={ref} style={{ ...AssetWrapper, width: "300px", height: ottSetting?.showProviderIcon ? "220px" : "180px", position: "relative", marginTop: 0 }} onMouseEnter={onMouseEnter}>
            {!isFree && !isLoggedIn && <img className={focused ? "crown focus" : "crown"} src={crown} />}
            <img style={{ ...style, width: "300px", height: "180px" }} onClick={onClick} className={focused ? 'card-img img-focused' : 'card-img'} src={utility.getPosterUrl(asset.Posters, OTT_POSTER_TYPE.Landscape)}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = ottSetting?.logo;
                }}
                alt="Card image cap" />
            {/* provider image */}
            {(ottSetting?.showProviderIcon && asset?.Provider?.LogoUrl?.length > 0) && <img src={asset?.Provider?.LogoUrl ?? ""} style={{
                position: "absolute",
                height: "35px",
                width: "35px",
                borderRadius: "5px",
                bottom: focused ? "0px" : "10px",
                left: focused ? "10px" : "20px",
                transition: "all 0.4s"
            }} />}
            {isWeb && <div style={{
                position: "absolute", bottom: 0, right: 0, left: 0, backgroundColor: "rgba(0,0,0,0.5)", color: "white", padding: "2px 5px", fontSize: "12px", backgroundColor: "white", opacity: focused ? 1 : 0, transition: "all 0.4s", display: "flex",
                flexDirection: "column", alignItems: "flex-start", gap: "2px"
            }}>
                <div style={{ fontSize: "13px", fontWeight: "bold", color: "black", letterSpacing: "1pxs", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%" }}>{asset.Title}</div>
                {asset?.routeType === OTTROUTETYPE.Player &&
                    <div style={{
                        fontSize: "12px", color: "black", marginTop: "5px", border: "1px solid black", padding: "2px 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%"
                    }} onClick={onClick}>
                        <i className="fa fa-play-circle pr-1" /> Play
                    </div>}
            </div>}
            {asset?.EpisodeNumber && !focused && (
                <div style={{
                    position: "absolute",
                    bottom: "10px",
                    left: (ottSetting?.showProviderIcon && asset?.Provider?.LogoUrl?.length > 0) ? "auto" : "20px",
                    right: (ottSetting?.showProviderIcon && asset?.Provider?.LogoUrl?.length > 0) ? "20px" : "auto",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    color: "white",
                    padding: "2px 5px",
                    fontSize: "12px"
                }}
                >
                    Ep.{asset?.EpisodeNumber}
                </div>
            )}
        </div>
    )
}

export default EpisodeCard